import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import Centralizer from "./Centralizer.js";

import "./GlobalHeader.css";

const GlobalHeader = ({ dispatch, isMobile }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { pathname } = useLocation();
  
  return (
    <div className="global-header">
      
    </div>
  );
};

export default connect(({
  game
}) => ({
  game
}))(GlobalHeader);
